<canvas #canvas class="stars-canvas"></canvas>
